module.exports = __webpack_public_path__ + "img/mensajero-icon.ee025cd2.png";